import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { theme } from '../../styles/theme';

interface NavbarProps {
  toggleSidebar: () => void;
}

const NavbarContainer = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing.md};
  background-color: #e9edc9;
  box-shadow: ${theme.shadows.small};
  position: sticky;
  top: 0;
  z-index: 100;
`;

const Logo = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  
  img {
    height: 40px;
    width: auto;
  }
  
  &:hover {
    text-decoration: none;
  }
`;

const MenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: ${theme.spacing.xs};
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    font-size: 1.5rem;
    color: ${theme.colors.dark};
  }
`;

const ProfileButton = styled(Link)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  text-decoration: none;
  
  svg {
    font-size: 1.75rem;
    color: ${theme.colors.dark};
    width: 28px;
    height: 28px;
  }
  
  span {
    color: ${theme.colors.dark};
    font-weight: 500;
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  &:hover {
    text-decoration: none;
    span {
      color: ${theme.colors.primary};
    }
    svg {
      color: ${theme.colors.primary};
    }
  }
`;

const Navbar: React.FC<NavbarProps> = ({ toggleSidebar }) => {
  const { user } = useAuth();
  
  const displayName = user?.name || 'Profile';
  
  return (
    <NavbarContainer>
      <MenuButton onClick={toggleSidebar} aria-label="Toggle menu">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
      </MenuButton>
      
      <Logo to="/">
        <img src="/logo-wide.png" alt="The Faithful Storyteller" />
      </Logo>
      
      <ProfileButton to="/profile">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          fill="currentColor"
          viewBox="0 0 16 16"
        >
          <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
          <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
        </svg>
        <span>{displayName}</span>
      </ProfileButton>
    </NavbarContainer>
  );
};

export default Navbar; 